import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ClearFiltersComponent } from './clear-filters/clear-filters.component';
import { FilterFieldDirective } from './table-filters/filter-field.directive';
import { TableFiltersComponent } from './table-filters/table-filters.component';

@NgModule({
    declarations: [TableFiltersComponent, ClearFiltersComponent, FilterFieldDirective],
    exports: [TableFiltersComponent, ClearFiltersComponent, FilterFieldDirective],
    imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule, ReactiveFormsModule],
})
export class TableFiltersModule {}
